// extracted by mini-css-extract-plugin
export default {"confirmSpeciesHeader":"styles_confirmSpeciesHeader__wvq2Q","fullName":"styles_fullName__Uuf0e","image":"styles_image__6LVdk"};